var collapsible_list_pair_rtlignore_default = {
  "container": "_7jfA2",
  "title": "Uhap7",
  "viewerContainer": "PtRhR",
  "titleContainer": "bJHz6",
  "content": "rKYmY",
  "expandIcon": "Hlnh-",
  "dndIcon": "_-654t",
  "RTL": "D1Ari",
  "LTR": "XDmzd",
  "itemContainer": "FXVOn",
  "itemContainerViewer": "P3x23",
  "mouseDown": "_6YZIc",
  "innerEditor": "YWUyU",
  "item": "Ap4Qx",
  "floatingAddPluginMenuWrapper": "_5FrcB"
};
export {
  collapsible_list_pair_rtlignore_default as default
};
//# sourceMappingURL=collapsible-list-pair.rtlignore-scss.js.map
